import {Injectable} from '@angular/core';
import {BasicInformation, HealthRequest} from '../model/SamanHealthFamilyModels';
import {HttpClientWrapperService} from '../config/http-client-wrapper.service';
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class HealthInsuranceService {
  constructor(private http: HttpClientWrapperService, private authService: AuthService) {
  }

  getBasicInsuranceList() {
    return this.http.get('samanAPI/Statistics/basicInsuranceList');
  }

  submitHealthRequest(basicInformation: BasicInformation, subRequests: HealthRequest[]) {
    const data: any = basicInformation;
    console.log(data);
    data.requests = subRequests;
    return this.http.post('samanAPI/HealthRequests/CreateHealthRequestAllAtOnce', data,
      this.authService.isAuthenticated() ? this.authService.decode().auth : null);
  }

  selectHealthOffer(requestID: number, offerID: number) {
    return this.http.get('SamanAPI/HealthRequests/SelectHealthOffer?offerID=' + offerID + '&requestID=' + requestID,
      this.authService.decode().auth);
  }

  getHealthOffers(requestID: number) {
    return this.http.get('SamanAPI/Statistics/healthOffers?requestID=' + requestID, this.authService.decode().auth);
  }

  getHealthRequestDetails(requestID: number) {
    return this.http.get('SamanAPI/Statistics/GetSubRequestsStatus?requestID=' + requestID, this.authService.decode().auth);
  }

  getHealthRequestsList() {
    return this.http.get('SamanAPI/Statistics/HealthRequestsList', this.authService.decode().auth);
  }

  uploadFile(subRequestID: number, fileType: string, file: File) {
    return this.http.upload('SamanAPI/FileControl/upload?subRequestID=' + subRequestID + '&fileType=' + fileType,
      file, fileType, this.authService.decode().auth);
  }

  submitForm(requestID: number, subRequestID: number, form: any) {
    form.subRequestID = subRequestID;
    form.requestID = requestID;
    console.log(form);
    for (const formKey in form) {
      if (!form.hasOwnProperty(formKey)) {
        continue;
      }
      if (typeof form[formKey] === 'boolean') {
        form[formKey] = form[formKey] ? 1 : 0;
      }
    }
    return this.http.post('SamanAPI/HealthRequests/SubmitSubRequest', form, this.authService.decode().auth);
  }

  downloadNewInsurance(requestID: number) {
    return this.http.get('SamanAPI/FileControl/InsuranceDownload?mode=directLink&requestID=' + requestID, this.authService.decode().auth);
  }

  submitInfo(value: any) {
    return this.http.get(
      `SamanAPI/HealthRequests/resubmitHeightWeightInfo?weight=${value.weight}&height=${value.height}&subRequestID=${value.subRequestID}`,
      this.authService.decode().auth);
  }
}
